import type { ButtonProps } from "@mui/material";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { SendMessageIcon } from "../../../../../shared/icons/SendMessageIcon";
import styles from "../styles.module.css";
import classNames from "classnames";

interface Props extends ButtonProps {
  sendMessage: () => void;
  isDisabled?: boolean;
  className?: string;
}

export const SendMessageButton = ({
  sendMessage,
  isDisabled,
  ...rest
}: Props) => {
  return (
    <AppIconButton
      onClick={sendMessage}
      className={classNames(
        styles["chat-button"],
        isDisabled && styles["send-btn-disabled"],
      )}
      disabled={isDisabled}
      {...rest}
    >
      <SendMessageIcon className={styles.icon} />
    </AppIconButton>
  );
};
